<template>
  <span v-if="text">
    <Tooltip v-if="showPopover" popper-class="max-width z-index-3000" :open-delay="200" effect="dark" placement="bottom-start">
      <div slot="content">{{expandedContext || text}}</div>
      <span  class="pointer">{{showText}}</span>
    </Tooltip>
    <span v-else> {{showText}} </span>
  </span>
  <span v-else> - </span>
</template>
<script>
export default {
  props: ['text','length','expandedContext'],
  computed: {
    showPopover() {
      let showForExpandedContent = true;
      if(this.expandedContext) {
        if(this.expandedContext === this.showText) {
          showForExpandedContent = false;
        }
      } else {
        showForExpandedContent = this.text.length > this.length ? true : false;
      }
      return  showForExpandedContent;
    },
    showText() {
      const len = parseInt(this.length, 10);
      const text = this.text ? this.text : '-';
      const textLen = this.text.length;
      return textLen <= len ? text : `${text.substring(0, len)}...`;
    },
  },

};
</script>
<style lang="scss">
  .testCapitalize {
      text-transform: capitalize
  }
  .z-index-3000 {
    z-index: 3000 !important;
  }
</style>
